import * as React from 'react';

import { MobileSegmentInfoProps } from './types';
import { getAirlinesList, getDurationString, getFlightDuration } from '../Results/utils';
import { getTransferShortLabel } from './utils';
import { format, removeDotsFromDate } from '../utils';

export const useMobileSegmentInfo = (componentProps: MobileSegmentInfoProps) => {
	const DEPARTURE_DATE_FORMAT = 'dd MMM, EEEEEE';
	const { segments, showFullInfo } = componentProps;

	const [detailsOpen, toggleDetails] = React.useState(false);

	const firstSegment = segments[0].segment;
	const lastSegment = segments[segments.length - 1].segment;
	const allAirlines = getAirlinesList(segments).map(airline => airline.name);
	const isNextDayArrival = firstSegment.departure.date !== lastSegment.arrival.date;
	const transferString = getTransferShortLabel(segments);

	const departureTime = firstSegment.departure.time.substr(0, 5);
	const departureDate = removeDotsFromDate(format(firstSegment.departure.date, DEPARTURE_DATE_FORMAT));
	const arrivalTime = lastSegment.arrival.time.substr(0, 5);
	const durationTime = getDurationString(getFlightDuration(segments, showFullInfo));

	const arrivalDate = removeDotsFromDate(format(lastSegment.arrival.date, DEPARTURE_DATE_FORMAT));

	const firstSegmentCity =
		firstSegment.departure?.airport?.city?.name ??
		firstSegment?.departure?.airport?.name ??
		firstSegment.departure.airport.iata;

	const lastSegmentCity =
		lastSegment.arrival?.airport?.city?.name ??
		lastSegment?.arrival?.airport?.name ??
		lastSegment.arrival.airport.iata;

	return {
		detailsOpen,
		toggleDetails,
		allAirlines,
		isNextDayArrival,
		transferString,
		firstSegment,
		lastSegment,
		departureTime,
		arrivalTime,
		durationTime,
		departureDate,
		firstSegmentCity,
		lastSegmentCity,
		arrivalDate
	};
};
